import { connect } from 'react-redux';

import {
    mapDispatchToProps,
    mapStateToProps,
    WishlistItemContainer as SourceWishlistItemContainer,
} from 'SourceComponent/WishlistItem/WishlistItem.container';
import fromCache from 'Util/Cache/Cache';
import { getProductInStock } from 'Util/Product/Extract';

export { mapStateToProps, mapDispatchToProps };

/** @namespace Advox/Component/WishlistItem/Container */
export class WishlistItemContainer extends SourceWishlistItemContainer {
    containerProps() {
        const { product } = this.props;

        return {
            ...super.containerProps(),
            inStock: fromCache(getProductInStock, [product]),
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WishlistItemContainer);
